function ComingSoonOverlay({ title, onBackHome }) {
  return (
    <div className="coming-soon-overlay" role="dialog" aria-modal="true" aria-label="Coming soon">
      <div className="coming-soon-card glass-panel">
        <p className="coming-soon-badge">Coming Soon</p>
        <h3>{title}</h3>
        <p>This section is under active development. More features will be available soon.</p>
        <button type="button" className="hero-play-btn" onClick={onBackHome}>
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default ComingSoonOverlay;
